// Licensed to Elasticsearch B.V under one or more agreements.
// Elasticsearch B.V licenses this file to you under the Apache 2.0 License.
// See the LICENSE file in the project root for more information
'use strict';
/* eslint camelcase: 0 */

/* eslint no-unused-vars: 0 */

var _objectWithoutProperties = require("/Users/jwolff/OneMedical/projects/onelife-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function buildIndicesExistsType(opts) {
  // eslint-disable-next-line no-unused-vars
  var makeRequest = opts.makeRequest,
      ConfigurationError = opts.ConfigurationError,
      handleError = opts.handleError,
      snakeCaseKeys = opts.snakeCaseKeys;
  /**
   * Perform a [indices.exists_type](http://www.elastic.co/guide/en/elasticsearch/reference/master/indices-types-exists.html) request
   *
   * @param {list} index - A comma-separated list of index names; use `_all` to check the types across all indices
   * @param {list} type - A comma-separated list of document types to check
   * @param {boolean} ignore_unavailable - Whether specified concrete indices should be ignored when unavailable (missing or closed)
   * @param {boolean} allow_no_indices - Whether to ignore if a wildcard indices expression resolves into no concrete indices. (This includes `_all` string or when no indices have been specified)
   * @param {enum} expand_wildcards - Whether to expand wildcard expression to concrete indices that are open, closed or both.
   * @param {boolean} local - Return local information, do not retrieve the state from master node (default: false)
   */

  var acceptedQuerystring = ['ignore_unavailable', 'allow_no_indices', 'expand_wildcards', 'local', 'pretty', 'human', 'error_trace', 'source', 'filter_path'];
  var snakeCase = {
    ignoreUnavailable: 'ignore_unavailable',
    allowNoIndices: 'allow_no_indices',
    expandWildcards: 'expand_wildcards',
    errorTrace: 'error_trace',
    filterPath: 'filter_path'
  };
  return function indicesExistsType(params, options, callback) {
    options = options || {};

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }

    if (typeof params === 'function' || params == null) {
      callback = params;
      params = {};
      options = {};
    } // check required parameters


    if (params['index'] == null) {
      var err = new ConfigurationError('Missing required parameter: index');
      return handleError(err, callback);
    }

    if (params['type'] == null) {
      var _err = new ConfigurationError('Missing required parameter: type');

      return handleError(_err, callback);
    }

    if (params.body != null) {
      var _err2 = new ConfigurationError('This API does not require a body');

      return handleError(_err2, callback);
    } // check required url components


    if (params['type'] != null && params['index'] == null) {
      var _err3 = new ConfigurationError('Missing required parameter of the url: index');

      return handleError(_err3, callback);
    } // validate headers object


    if (options.headers != null && typeof options.headers !== 'object') {
      var _err4 = new ConfigurationError("Headers should be an object, instead got: ".concat(typeof options.headers));

      return handleError(_err4, callback);
    }

    var warnings = [];

    var _params = params,
        method = _params.method,
        body = _params.body,
        index = _params.index,
        type = _params.type,
        querystring = _objectWithoutProperties(_params, ["method", "body", "index", "type"]);

    querystring = snakeCaseKeys(acceptedQuerystring, snakeCase, querystring, warnings);

    if (method == null) {
      method = 'HEAD';
    }

    var ignore = options.ignore;

    if (typeof ignore === 'number') {
      options.ignore = [ignore];
    }

    var path = '';
    path = '/' + encodeURIComponent(index) + '/' + '_mapping' + '/' + encodeURIComponent(type); // build request object

    var request = {
      method: method,
      path: path,
      body: null,
      querystring: querystring
    };
    options.warnings = warnings.length === 0 ? null : warnings;
    return makeRequest(request, options, callback);
  };
}

module.exports = buildIndicesExistsType;